export default __webpack_public_path__ + "static/media/durvis-6-min.8b1616e4.jpg";